import {
  GET_LIST_PHIKHAC,
  GET_LIST_PHIKHAC_SUCCESS,
  GET_LIST_PHIKHAC_FAILURE,
  GET_LIST_PHIKHAC_CHOVAY,
  GET_LIST_PHIKHAC_CHOVAY_SUCCESS,
  GET_LIST_PHIKHAC_CHOVAY_FAILURE,
} from "actions/PhiKhac/actionTypes";

const initialState = {
  getListPhiKhacLoading: false,
  phiKhacFetched: false,
  objListPhiKhac: [],
  totalRow: 0,
  objChoVay_PhiKhac: [],
};

const getListPhiKhac = (state, action) => ({
  ...state,
  getListPhiKhacLoading: true,
  phiKhacFetched: true,
});

const getListPhiKhacSuccess = (state, action) => {
  return {
    ...state,
    getListPhiKhacLoading: false,
    objListPhiKhac: action.payload,
    phiKhacFetched: true,
  };
};

const getListPhiKhacFailed = (state, action) => ({
  ...state,
  getListPhiKhacLoading: false,
  objListPhiKhac: [],
  phiKhacFetched: true,
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_PHIKHAC:
      return getListPhiKhac(state, action);
    case GET_LIST_PHIKHAC_SUCCESS:
      return getListPhiKhacSuccess(state, action);
    case GET_LIST_PHIKHAC_FAILURE:
      return getListPhiKhacFailed(state, action);
    case GET_LIST_PHIKHAC_CHOVAY:
      return getListPhiKhac(state, action);
    case GET_LIST_PHIKHAC_CHOVAY_SUCCESS:
      return getListPhiKhacSuccess(state, action);
    case GET_LIST_PHIKHAC_CHOVAY_FAILURE:
      return getListPhiKhacFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
